import type { DocMigration } from "../docMigration";
import { migrateModelToExtendDocEntityBase } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_61: DocMigration = {
  maxSchemaVersion: "0.0.61",
  description: "Refactor ReferenceGeom and Elevation to implement DocEntityBase",
  apply(json: any) {
    if (json.referenceGeom) {
      migrateModelToExtendDocEntityBase(json, "referenceGeom");
    }

    if (json.elevations) {
      migrateModelToExtendDocEntityBase(json, "elevations");
    }

    return json;
  },
};

export default migration_0_0_61;
